var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-custom-query-view"},[_c('StockCustomQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }